export class InductionTypes {
    public ID: number = 0;
    public Title: string = "";
    public Description: string = "";
    public ExpiryMonths: number = 0;
    public questions:InductionSlideSelection[]=[];
    public Active: boolean = true;

}

export class InductionSlideSelection {
    public ID: number = 0;
    public Title: string = "";
    public InductionType: number|null = null;
    public Order: number = 0;
    public Active: boolean = true;
}

export class InductionVM {
    public InductionTypes: InductionTypes[] = []
    public Selections: InductionSlideSelection[] = []
    public success: boolean = false;
    public message: string = "";
    public States:StateVM[]
}

export class StateVM {
    public ID:number;
    public SideCode:string;
    public StateName:string;
}

export class ModalNewCategory{
    public InductionTypeName :string=""
    public TypeDesc :string=""
    public ExpiryMonths :number|null=null
    public active :boolean;
}

export class ModalNewSection{
    public selectionName:string="";
    public typeid:number=0;
    public order:number=0;
}


export class ModalUpdateCategory{
    public typeID:number=0;
    public InductionTypeName :string=""
    public TypeDesc :string=""
    public ExpiryMonths :number|null=null
    public active :boolean=true;

}

export class ModalUpdateSection{
    public typeid:number=0;
    public selectionName :string=""
    public order :number=0;
    public selectionId :number=0;
    public active :boolean=true;
}
